// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { degen as _degen } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the degen chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 666666666
 * Chain Name: Degen
 * Default Block Explorer: https://explorer.degen.tips
 * Default RPC URL: https://rpc.degen.tips
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { degen } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: degen,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const degen = createCommon({
	..._degen,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
